import { graphql } from 'parkdepot-shared/gql'

const B2C_GET_COMPLETED_ORDERS = graphql(`
    query B2CGetCompletedOrders($plates: [String!]!) {
        b2c_get_completed_orders(plates: $plates) {
            orders {
                ...B2COrderResponse
            }
        }
    }
`)

export default B2C_GET_COMPLETED_ORDERS
